var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-card',{staticClass:"py-3"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }